import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  DialogActions,
  appBarClasses,
  FormGroup,
  FormControlLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { edit_template, get_template } from "../Api service/APIvariables";
import Switch from "@mui/material/Switch";

const DialogModal = ({
  openDialog,
  setOpenDialog,
  isAddTemplate,
  fetchTemplates,
  template_id,
  hashReadOnlyButton = false,
  setHashReadOnlyButton = false,
}) => {
  const [particularTemplate, setParticularTemplate] = useState({
    id: "",
    template_name: "",
    subject: "",
    message: "",
  });
  const [readOnly, setReadOnly] = useState(false);
  // const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [templatesOne, setTemplatesOne] = useState([]);
  const [templates, setTemplates] = useState([]);
  // const [isToggled, setIsToggled] = useState();

  const fetchSingleTemplate = async () => {
    if (!template_id) return;
    try {
      const user_id = localStorage.getItem("user_id");
      const formData = new FormData();
      formData.append("user_id", user_id);
      formData.append("template_id", template_id);
      const token = localStorage.getItem("auth_token");
      // console.log(token);

      const response = await fetch(get_template, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch templates");
      }

      const result = await response.json();

      if (result?.data) {
        // Add a unique incremental ID to each template

        setParticularTemplate(result.data);
      } else {
        // Handle case when there are no templates
        // console.log("No templates found:", result.message);
        setTemplates([]);
        setTemplatesOne([]);
        // Optionally show a message to the user or update state for no data
      }
    } catch (error) {
      // console.error("Error fetching templates:", error);
      setLoading(false); // You may want to set loading to false here too
    }
  };
  // console.log(templatesOne);
  useEffect(() => {
    if (template_id) {
      fetchSingleTemplate();
    }
  }, [template_id]);
  console.log(template_id);

  const handleInputChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setParticularTemplate((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Closing dialog function
  const handleCloseDialog = () => {
    if (hashReadOnlyButton) {
      setHashReadOnlyButton(false);
    }
    setOpenDialog(false);
    setReadOnly(false);
  };
  useEffect(() => {
    setReadOnly(hashReadOnlyButton);
    // console.log("hashReadOnlyButton");
  }, [hashReadOnlyButton]);
  const updateTemplates = async () => {
    try {
      const user_id = localStorage.getItem("user_id");
      const formData = new FormData();
      formData.append("user_id", user_id);
      formData.append("template_id", particularTemplate.id);
      formData.append("template_name", particularTemplate.template_name);
      formData.append("subject", particularTemplate.subject);
      formData.append("message", particularTemplate.message);
      // console.log("Templates to be sent:", JSON.stringify(templatesOne));

      const token = localStorage.getItem("auth_token");
      // console.log("Updating Template - Token:", token);

      const response = await fetch(edit_template, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message || "Failed to update template");
      }

      const result = await response.json();

      // Check if the result contains expected data
      if (!result?.error) {
        // console.log("Template updated successfully:", result);
        // Close dialog after successful update
        fetchTemplates(); // Refresh the template list
        handleCloseDialog();
      } else {
        // console.log("Template update failed: No data returned from the API.");
      }
    } catch (error) {
      // console.error("Error updating template:", error);
      // Optionally, show an error message to the user
      // alert(`Error updating template: ${error.message}`);
    }
  };
  // useEffect(() => {
  //   updateTemplates();
  // }, [template_id]);

  return (
    <Dialog
      open={openDialog}
      onClose={handleCloseDialog}
      sx={{
        "& .MuiDialog-paper": {
          width: "400px",
          maxWidth: "90%",
          height: "auto",
        },
      }}
    >
      <DialogTitle>
        {isAddTemplate
          ? "Add Template"
          : readOnly
            ? "View Template"
            : "Edit Template"}{" "}
        {/* <FormGroup>
          <FormControlLabel control={<Switch defaultChecked />} label="Edit" />
        </FormGroup> */}
        {hashReadOnlyButton && (
          <FormControlLabel
            control={
              <Switch
                checked={readOnly}
                onChange={(e) => setReadOnly(e.target.checked)}
              />
            }
            label={readOnly ? "Edit" : "View"}
            labelPlacement="start"
            sx={{ position: "absolute", right: 48, top: 12 }}
          />
        )}
        <IconButton
          onClick={handleCloseDialog}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TextField
          inputProps={{
            readOnly: readOnly,
            // disab,
          }}
          disabled={readOnly}
          label="Template Name"
          variant="outlined"
          fullWidth
          name="template_name"
          value={particularTemplate?.template_name}
          onChange={handleInputChange}
          sx={{
            marginTop: "10px",
            marginBottom: 1,
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
            },
            "& .MuiInputLabel-root": {
              fontSize: "16px",
              color: "#333",
            },
          }}
        />
        <TextField
          inputProps={{
            readOnly: readOnly,
          }}
          disabled={readOnly}
          label="Subject"
          variant="outlined"
          fullWidth
          name="subject"
          value={particularTemplate?.subject || ""}
          onChange={handleInputChange}
          sx={{
            marginTop: "10px",
            marginBottom: 1,
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
            },
            "& .MuiInputLabel-root": {
              fontSize: "16px",
              color: "#333",
            },
          }}
        />
        <label
          style={{
            display: "block",
            fontSize: "16px",
            color: "#333",
            marginTop: "10px",
            marginBottom: "5px",
          }}
        >
          Message
        </label>
        <textarea
          // readOnly={readOnly}
          disabled={readOnly}
          name="message"
          value={particularTemplate.message || ""}
          onChange={handleInputChange}
          style={{
            width: "100%",
            minHeight: "100px",
            padding: "10px",
            fontSize: "14px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            resize: "both", // Allows resizing from the bottom-right corner
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleCloseDialog}
          color="error"
          sx={{ textTransform: "none" }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            updateTemplates();
            handleCloseDialog();
          }}
          color="success"
          sx={{ textTransform: "none" }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogModal;
